<div class="section-header">
  <span data-testid="select-template-header">{{ headerLabel }}</span
  >&nbsp;
  <mat-icon [matTooltip]="titleLabel">help</mat-icon>
</div>
<div *ngIf="selected.template?.header?.media_type" class="template-medias">
  <div class="header-media-wrapper">
    <button
      *ngIf="!selected.template.header.media_url; else showMedia"
      mat-raised-button
      type="button"
      (click)="fileInput.click()">
      <mat-icon *ngIf="selected.template.header.media_type === AttachmentMediaTypeEnum.Image">image</mat-icon>
      <mat-icon *ngIf="selected.template.header.media_type === AttachmentMediaTypeEnum.Document">attach_file</mat-icon>
      <mat-icon *ngIf="selected.template.header.media_type === AttachmentMediaTypeEnum.Video">movie</mat-icon>
      {{ uploadMediaTypeLabel }}
    </button>
  </div>

  <ng-template #showMedia>
    <ng-container *ngIf="selected.template.header.media_type === AttachmentMediaTypeEnum.Image">
      <img [src]="selected.template.header.media_url" />
      <div class="buttons-media-wrapper" *ngIf="!selected.template.header.static">
        <button mat-raised-button type="button" (click)="fileInput.click()">
          <mat-icon>image</mat-icon>
          <span>{{ editMediaTypeLabel }}</span>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="selected.template.header.media_type === AttachmentMediaTypeEnum.Document">
      <div>
        <mat-icon>document</mat-icon>
        <a #document target="_blank" [href]="selected.template.header.media_url">
          {{ selected.template.header.filename }}
        </a>
      </div>
      <div class="buttons-media-wrapper" *ngIf="!selected.template.header.static">
        <button mat-raised-button type="button" (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon>
          <span>{{ editMediaTypeLabel }}</span>
        </button>
        <button [matTooltip]="downloadMediaTypeLabel" mat-raised-button type="button" (click)="document.click()">
          <mat-icon>download</mat-icon>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="selected.template.header.media_type === AttachmentMediaTypeEnum.Video">
      <video class="video" [src]="selected.template.header.media_url" width="50%" preload="" controls=""></video>
      <div class="buttons-media-wrapper" *ngIf="!selected.template.header.static">
        <button mat-raised-button type="button" (click)="fileInput.click()">
          <mat-icon>movie</mat-icon>
          <span>{{ editMediaTypeLabel }}</span>
        </button>
      </div>
    </ng-container>
  </ng-template>

  <input #fileInput (change)="uploadMedia($event)" [accept]="supportedMediaTypes" hidden type="file" />
</div>

<ion-progress-bar *ngIf="uploading" [value]="uploadProgress$ | async"></ion-progress-bar>

<div class="template-params">
  <form [formGroup]="form">
    <ng-container formArrayName="params">
      <ng-container *ngFor="let paramForm of params.controls; let i = index">
        <div [formGroup]="$any(paramForm)" class="param-row">
          <app-select
            [showEmptyOption]="true"
            [control]="$any(paramForm).controls.customField"
            [items]="customFieldsChoices"
            [labelKey]="'parameters/quick_replies/details/add_a_custom_field'"></app-select>

          <span class="or-separator"> <span translate="and"></span>/<span translate="or"></span> </span>

          <mat-form-field>
            <mat-label>
              <{{ selected.template?.displayed_placeholders['{{' + (i + 1) + '}}']?.label || '{{ ' + (i + 1) + ' }}' }}>
              <span *ngIf="paramForm.value.customField; else valueLabel" translate="default-value"></span>
              <ng-template #valueLabel>
                <span translate="value"></span>
              </ng-template>
            </mat-label>
            <input matInput formControlName="text" type="text" [attr.data-testid]="'template-param-' + i" />
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
  </form>
</div>

<div class="buttons-params">
  <form [formGroup]="form">
    <ng-container formArrayName="couponCodeButtonParams">
      <ng-container *ngFor="let couponCodeButtonParam of couponCodeButtonParams.controls; let i = index">
        <div [formGroup]="$any(couponCodeButtonParam)">
          <mat-form-field floatLabel="always" class="w-100 url-buttons-param">
            <mat-label>
              {{ 'task/whatsapp-template/footer/copy-code-button/label' | translate }}
            </mat-label>
            <input matInput formControlName="example" type="text" />
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
    <ng-container formArrayName="urlButtonParams">
      <ng-container *ngFor="let urlButtonParamForm of urlButtonParams.controls; let i = index">
        <div [formGroup]="$any(urlButtonParamForm)">
          <mat-form-field floatLabel="always" class="w-100 url-buttons-param">
            <mat-label>
              {{
                'task/whatsapp-template/footer/url-button/label' | translate: { text: urlButtonParamForm.value.text }
              }}
            </mat-label>
            <span matPrefix>{{ urlButtonParamForm.value.url }}</span>
            <input matInput formControlName="example" type="text" />
            <mat-hint>
              {{ 'task/whatsapp-template/footer/url-button/hint' | translate }}
            </mat-hint>
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
  </form>
</div>

<div data-testid="template-preview" class="template-preview">
  {{ templatePreview }}
</div>

<p *ngIf="selected?.template?.limited_time_offer" class="change-expiration-date-delay">
  <mat-radio-group [formControl]="expirationTypeControl">
    <strong>{{ 'task/whatsapp-template/limited-time-offer/expiration-type/label' | translate }}</strong>
    <mat-radio-button [value]="LimitedTimeOfferExpirationTypeEnum.DATE_TIME_PICKER">
      {{ 'task/whatsapp-template/limited-time-offer/expiration-type/choice/expiration-date' | translate }}
    </mat-radio-button>
    <mat-radio-button [value]="LimitedTimeOfferExpirationTypeEnum.DELAY">
      {{ 'task/whatsapp-template/limited-time-offer/expiration-type/choice/expiration-delay' | translate }}
    </mat-radio-button>
  </mat-radio-group>

  <ng-container [ngSwitch]="expirationTypeControl.value">
    <ng-container *ngSwitchCase="LimitedTimeOfferExpirationTypeEnum.DATE_TIME_PICKER">
      <button type="button" mat-raised-button (click)="displayDateTimeModal = true">
        <span *ngIf="selected.limitedTimeOffer?.expirationDate; else selectNewDate">
          {{ 'task/whatsapp-template/limited-time-offer/change-expiration-date' | translate }}:
          {{ selected.limitedTimeOffer.expirationDate | dateTimezone: 'medium' }}
        </span>
        <ng-template #selectNewDate>{{
          'task/whatsapp-template/limited-time-offer/set-expiration-date' | translate
        }}</ng-template>
      </button>
      <app-date-time-schedule-modal
        *ngIf="displayDateTimeModal"
        [dateTime]="selected.limitedTimeOffer?.expirationDate || null"
        confirmBtnTextKey="ok"
        (closeModal)="closeDateTimeModal($event)"></app-date-time-schedule-modal>
    </ng-container>

    <ng-container *ngSwitchCase="LimitedTimeOfferExpirationTypeEnum.DELAY">
      <div class="select-expiration-delay">
        <app-select labelKey="months" [items]="months" [control]="expirationDelayForm.get('months')"></app-select>
        <app-select labelKey="days" [items]="days" [control]="expirationDelayForm.get('days')"></app-select>
        <app-select labelKey="hours" [items]="hours" [control]="expirationDelayForm.get('hours')"></app-select>
        <app-select labelKey="minutes" [items]="minutes" [control]="expirationDelayForm.get('minutes')"></app-select>
      </div>
    </ng-container>
  </ng-container>
</p>

<button
  mat-button
  color="primary"
  data-testid="select-template-btn"
  (click)="openSelectWhatsappTemplate()"
  type="button"
  [disabled]="!selected.template && !availableTemplates?.length">
  {{ selectTemplateLabel }}
</button>
